<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Street Preview"
      id="admin_edit_street_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Edit
      </v-btn>
      <v-btn
        :to="
          '/admin/locations/streets/view/' +
          $route.params.id +
          '/delete'
        "
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-trash-can</v-icon> Remove Street
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="street.name"
        :icon="'mdi-flag'"
        :img_src="'https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1606031411/botswana%20services/website%20assets/street_ypavnx.jpg'"
        :facts="view_header_facts"
        :description="''"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Edit Street Form"
      id="admin_edit_street_form"
    ></CardedSectionHeader>
    <AdminStreetsAdd
      @on-show-loader="show_loader"
      @on-hide-loader="hide_loader"
      :is_editing="true"
      :is_loading="is_loading"
      ref="add_street_form_comp_ref"
      @on-success-edit="on_success_edit"
    >
    </AdminStreetsAdd>
  </div>
</template>
<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import ViewHeader from "../../../components/ViewHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import AdminStreetsAdd from "./AdminStreetsAdd";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminStreetssEdit",
  components: {
    CardedSectionHeader,
    ViewHeader,
    CardedDisplay,
    AdminStreetsAdd,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      street: {
        id: 0,
        name: "",
        country: {
            id: 0,
            name: ""
        },
        district: {
            id: 0,
            name: ""
        },
        city: {
            id: 0,
            name: ""
        },
        ward: {
            id: 0,
            name: ""
        }
      },
    };
  },
  methods: {
    show_loader() {
      this.$emit("on-show-loader");
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    load_item(){
      ServerClient.Locations.get_street(
      {
        id: this.$route.params.id,
        is_edit: true,
      },
      (res) => {
        this.$emit("on-hide-loader");
        this.street = res;
        var edit = {
            ...res
        };
        delete edit.country;
        delete edit.district;
        delete edit.city;
        delete edit.ward;
        this.$refs.add_street_form_comp_ref.fill_edit_street(edit);
      },
      (errors) => {
        this.$emit("on-hide-loader");
        console.log(
          "Errors while loading street details on admin edit street",
          errors
        );
      }
    );
    },
    on_success_edit(){
      this.load_item();
    }
  },

  computed: {
    view_header_facts() {
      var facts = [
          {
              text: "Ward",
              val: this.street.ward.name
          },
        {
          text: "City",
          val: this.street.city.name,
        },
        { text: "District:", val: this.street.district.name },
        { text: "Country:", val: this.street.country.name },
      ];
      return facts;
    },
  },

  mounted() {
    var item_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Admin Edit Street",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "Streets",
          disabled: false,
          href: "/admin/locations/streets/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/locations/streets/list/view/" + item_id,
        },
        {
          text: "Edit",
          disabled: true,
          href:"/admin/locations/streets/list/view/"+item_id+"/edit" 
        }
      ],
      navbar_cols: 3
    });
    this.load_item();
  },
};
</script>

